'use client';
import { motion } from 'framer-motion';
import { useAppDispatch, useAppSelector } from '@/app/lib/store/hooks';
import { toggleDrawer } from '@/app/lib/store/drawer-slice';
import styles from './animated-hamburger.module.css';

export default function AnimatedHamburger() {
  const isOpen = useAppSelector(state => state.drawer.isOpen);
  const dispatch = useAppDispatch();

  return (
    <button
      className={styles.Button}
      onClick={() => dispatch(toggleDrawer())}
    >
      <motion.div
        initial={false}
        animate={isOpen ? 'open' : 'closed'}
      >
        <motion.div
          className={styles.Line}
          variants={line1Variants}
        />
        <motion.div
          className={styles.Line}
          variants={line2Variants}
        />
        <motion.div
          className={styles.Line}
          variants={line3Variants}
        />
      </motion.div>
    </button>
  );
}

// Framer Motion Variants
const line1Variants = {
  open: {
    rotate: 45,
    y: 3,
    transition: { type: 'spring', stiffness: 260, damping: 20 }
  },
  closed: {
    rotate: 0,
    y: 0,
    transition: { type: 'spring', stiffness: 260, damping: 20 }
  }
};

const line2Variants = {
  open: { opacity: 0 },
  closed: { opacity: 1 }
};

const line3Variants = {
  open: {
    rotate: -45,
    y: -5,
    transition: { type: 'spring', stiffness: 260, damping: 20 }
  },
  closed: {
    rotate: 0,
    y: 0,
    transition: { type: 'spring', stiffness: 260, damping: 20 }
  }
};
